export const environment = {
  production: false,
  API_URL: 'https://confapidev.larvol.com',
  URL_GPT: ''
};
